import React, { useContext, useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../../config/AuthContext";
import { Button, FloatButton, Table, TableProps, Tag } from "antd";
import { ColumnsType } from "antd/es/table";
import BbddColors from "../../../../styles/BbddColors";
import { BiRefresh } from "react-icons/bi";
import { GetAlumneId } from "../../../../dao/GetAlumneId";
import { GetUsuariIdActivitats } from "../../../../dao/GetUsuariIdActivitats";
import { GetBbddUsersIdPractiquesId } from "../../../../dao/bbdd/GetBbddUsersIdPractiquesId";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import { BsCheck } from "react-icons/bs";
import { PostBbddValidar } from "../../../../dao/bbdd/PostBbddValidar";
import AvaluacioColors from "../../../../styles/AvaluacioColors";
import { FaRegQuestionCircle, FaEye } from "react-icons/fa";
import Editor from "@monaco-editor/react";

const ActivitatsIdExercicis = () => {
    const { isLoggedIn, userId, setBreadCrumb } = useContext(AuthContext);
    const { id_activitat, id_alumne } = useParams();
    const [dades, setDades] = useState<any>();
    const [loading, setLoading] = useState(false);
    const [expandedRowKeys, setExpandedRowKeys] = useState<React.Key[]>([]);
    const navigate = useNavigate();

    useEffect(() => {
        if (isLoggedIn) checkDades();
    }, [id_activitat]);

    async function checkDades() {
        setLoading(true);
        const data = await GetBbddUsersIdPractiquesId(id_activitat + "", id_alumne + "");
        const alu = await GetAlumneId(id_alumne + "");
        const prac = await GetUsuariIdActivitats(userId);
        const actividad = prac.find((act: any) => act.id === Number(id_activitat));

        setBreadCrumb(
            [
                { nom: 'Home', nav: '/home' },
                { nom: 'bbdd', nav: '/database' },
                { nom: 'activitats', nav: `/database/activitats` },
                { nom: `${actividad.nom}`, nav: `/database/activitats/${id_activitat}` },
                { nom: 'alumnes', nav: `/database/activitats/${id_activitat}/alumnes` },
                { nom: `${alu && (alu.alumne.nom + " " + alu.alumne.cognoms)}`, nav: `/database/activitats/${id_activitat}` }
            ],
            true
        );
        setDades(data);
        setLoading(false);
    }

    async function handleCheck(ele: any) {
        setLoading(true);
        await PostBbddValidar(id_alumne + "", ele.id, id_activitat);
        await checkDades();
    }

    /** Subfila expandida */
    const subRowRender = (record: any) => (
        <div
            style={{
                backgroundColor: "#fafafa",
                padding: "16px",
                borderRadius: "10px",
                boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
                display: "flex",
                flexDirection: "column",
                gap: "20px",
            }}
        >
            <div>
                <h5 style={{ color: BbddColors.colors.color5 }}>Enunciat:</h5>
                <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
                    {record.enunciat || "*Sense enunciat*"}
                </ReactMarkdown>
            </div>

            <div>
                <h5 style={{ color: BbddColors.colors.color4 }}>Resposta Alumne:</h5>
                <Editor
                    height="30vh"
                    defaultLanguage="sql"
                    value={record.actual || "-- Sense resposta --"}
                    theme="vs-light"
                    options={{ readOnly: true, minimap: { enabled: false } }}
                />
            </div>

            <div>
                <h5 style={{ color: BbddColors.colors.color3 }}>Solució Esperada:</h5>
                <Editor
                    height="30vh"
                    defaultLanguage="sql"
                    value={record.solucio || "-- Sense solució --"}
                    theme="vs-light"
                    options={{ readOnly: true, minimap: { enabled: false } }}
                />
            </div>

            {record.err && (
                <div>
                    <h5 style={{ color: "red" }}>Error complet:</h5>
                    <pre
                        style={{
                            background: "#fff5f5",
                            border: "1px solid #ffccc7",
                            borderRadius: "8px",
                            padding: "12px",
                            overflowX: "auto",
                        }}
                    >
                        {record.err}
                    </pre>
                </div>
            )}
        </div>
    );

    /** Columnas principales */
    const columns: ColumnsType<any> = [
        {
            key: 'expand',
            width: 40,
            render: (_, record) =>
                (record.enunciat || record.actual || record.solucio) && (
                    <FaEye
                        style={{
                            cursor: "pointer",
                            fontSize: 16,
                            color: expandedRowKeys.includes(record.id)
                                ? BbddColors.colors.color4
                                : "gray",
                        }}
                        onClick={() => {
                            if (expandedRowKeys.includes(record.id))
                                setExpandedRowKeys([]);
                            else setExpandedRowKeys([record.id]);
                        }}
                    />
                ),
        },
        {
            key: 'id',
            dataIndex: 'id',
            title: 'ID',
            width: 70,
        },
        {
            key: 'estat',
            dataIndex: 'estat',
            title: 'Estat',
            width: 120,
            render: (e) => (
                <Tag color={e === 2 ? BbddColors.colors.color6 : BbddColors.colors.color2}>
                    {e === 2 ? 'CORRECTE' : 'INCORRECTE'}
                </Tag>
            ),
        },
        {
            key: 'err',
            dataIndex: 'err',
            title: 'Error',
            width: 300,
            render: (e) => (e ? e.substring(0, 80) + (e.length > 80 ? "..." : "") : "Sense errors"),
        },
        {
            key: 'actions',
            dataIndex: 'actions',
            title: 'Accions',
            width: 100,
            render: (_, ele) => (
                <>
                    {ele.estat !== 2 && (
                        <Button
                            style={{ backgroundColor: BbddColors.colors.color6 }}
                            onClick={() => handleCheck(ele)}
                        >
                            <BsCheck />
                        </Button>
                    )}
                    {(ele.reclamacions !== null || ele?.reclamacions > 0) && (
                        <Button disabled={true} style={{ backgroundColor: BbddColors.colors.color4 }}>
                            <FaRegQuestionCircle />
                        </Button>
                    )}
                </>
            ),
        },
    ];

    const tableProps: TableProps<any> = { loading };

    return (
        <>
            <Table
                showHeader={true}
                size={"small"}
                title={() => "EXERCICIS"}
                {...tableProps}
                bordered
                columns={columns}
                dataSource={dades}
                rowKey="id"
                expandable={{
                    expandedRowKeys,
                    expandIconColumnIndex: -1,
                    expandedRowRender: subRowRender,
                }}
            />

            {!loading && (
                <FloatButton
                    shape="circle"
                    onClick={() => checkDades()}
                    style={{ insetInlineStart: 97, backgroundColor: AvaluacioColors.colors.color6 }}
                    icon={<BiRefresh />}
                />
            )}
        </>
    );
};

export default ActivitatsIdExercicis;
